import PageLayout from "@/components/PageLayout";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    slug: "/bedrijfskleding-werkkleding",
    title: "Bedrijfskleding of werkkleding bedrukken",
    excerpt: "Bedrijfskleding is zowel functioneel als promotioneel. Lees meer over onze werkkleding en veiligheidskleding.",
  },
  {
    slug: "/t-shirts-bedrukken-voor-het-zomerseizoen",
    title: "T-shirts bedrukken voor het zomerseizoen",
    excerpt: "Bereid je voor op de zomer met bedrukte T-shirts voor je team, bedrijf of evenement.",
  },
  {
    slug: "/zeefdruk-of-transferdruk",
    title: "Zeefdruk of transferdruk?",
    excerpt: "Ontdek de verschillen tussen zeefdruk en transferdruk en welke techniek het beste bij jouw project past.",
  },
  {
    slug: "/t-shirt-bedrukken",
    title: "T-shirt bedrukken",
    excerpt: "Alles wat je moet weten over het bedrukken van T-shirts bij Magic Print.",
  },
  {
    slug: "/veiligheidsvesten-veiligheidshesjes",
    title: "Veiligheidsvesten en veiligheidshesjes",
    excerpt: "Veiligheidsvesten en hesjes bedrukken met uw bedrijfslogo voor maximale zichtbaarheid.",
  },
];

const Blog = () => (
  <PageLayout
    title="Blog"
    metaDescription="Blog van Magic Print Den Haag. Tips en informatie over kleding bedrukken, druktechnieken, werkkleding en meer."
  >
    <h1 className="text-3xl md:text-5xl font-bold mb-8">
      Magic Print Blog
    </h1>

    <div className="space-y-6">
      {blogPosts.map((post) => (
        <Link
          key={post.slug}
          to={post.slug}
          className="block p-6 rounded-xl bg-card border border-border hover:border-primary/50 transition-colors"
        >
          <h2 className="text-xl font-bold mb-2 text-foreground">{post.title}</h2>
          <p className="text-muted-foreground">{post.excerpt}</p>
        </Link>
      ))}
    </div>
  </PageLayout>
);

export default Blog;
